
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"149","height":"149","viewBox":"0 0 149 149","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"transform":"translate(2 2)","stroke":"currentColor","stroke-width":"3","fill":"none","fill-rule":"evenodd"}},[_c('circle',{attrs:{"stroke-linecap":"square","cx":"72.5","cy":"72.5","r":"72.5"}}),_c('path',{attrs:{"stroke-linecap":"round","stroke-linejoin":"round","d":"M47 71.652L67 92l36-39"}})])]);
        };
      

        module.exports = {
          
          render: render,
        };
      